














































































import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  DISPENSARIES_ADDED,
  FETCH_DISPENSARIES,
  SHOW_SNACKBAR,
} from '../../common/constants';
import Dispensary from '../../common/model/Dispensary';
import { eventBus } from '../../main';
import brandModule from '../../store/modules/brand.module';
import dispensaryModule from '../../store/modules/dispensary.module';
import errorModule from '../../store/modules/error.module';

@Component({
  components: {},
})
export default class RegisterBrandStepThree extends Vue {
  // Data
  headers = [
    { text: 'Name', value: 'name' },
    { text: 'City', value: 'city' },
    { text: 'State', value: 'state' },
    { text: 'Address', value: 'address' },
  ];

  selectedHeaders = [{ text: 'Name', value: 'name' }];

  search = '';

  selectedDispensaries = [];

  errorText = 'Unable to retrieve dispensaries at this time.';

  // Methods
  mounted(): void {
    eventBus.$on(FETCH_DISPENSARIES, this.fetchDispensaries);
  }

  get dispensaries() {
    return dispensaryModule.dispensaryList;
  }

  async fetchDispensaries() {
    await dispensaryModule.fetchDispensariesByState('California');
    if (errorModule.hasError) {
      errorModule.clearError();
    }
  }

  async submitBrandDispensaries() {
    if (!brandModule.brand) {
      return;
    }
    await dispensaryModule.addDispensariesToBrand({
      brandId: brandModule.brand.id,
      chosenDispensaries: this.selectedDispensaries,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    this.$emit('submitForm');
    eventBus.$emit(DISPENSARIES_ADDED);
  }
}
